module.exports = __webpack_public_path__ + "fonts/Roboto-Light.4ca61622.woff2";